import { zSchema } from "@zeal/common";

export const getCompanyDocumentPdfParamsSchema = zSchema.object({
  document_key: zSchema.string().min(1),
  companyID: zSchema.string().min(1),
  accessToken: zSchema.string(),
});

export type TGetCompanyDocumentPdfParams = zSchema.infer<
  typeof getCompanyDocumentPdfParamsSchema
>;
